import { type Types, types } from "./types";

export const labelController = (type: Types) => {
  return types[type];
};
